/**
 * Alta de los stakeholders del wizard de creación (OT-0065).
 *
 * El usuario actual NO va aquí: el backend lo da de alta como líder en el
 * mismo `POST /projects`, y por eso estas altas pasan el guard de líder de
 * `POST /members`. Se esperan todas y se devuelven las que fallaron, para
 * que el wizard diga cuáles y por qué en vez de perderlas en silencio.
 */

import { addProjectMember } from '../../../api/project_members'
import { inferRaciFromStakeholderRole, isValidEmail, type WizardState } from './types'

export interface StakeholderFailure {
  email: string
  error: unknown
}

/** Da de alta a los stakeholders, en paralelo, y devuelve los que fallaron
 * con su error. */
export async function persistStakeholders(
  accessToken: string,
  projectId: string,
  state: Pick<WizardState, 'stakeholders'>,
): Promise<StakeholderFailure[]> {
  const stakeholders = state.stakeholders.filter((s) => isValidEmail(s.email))
  const results = await Promise.allSettled(
    stakeholders.map((s) =>
      addProjectMember(accessToken, projectId, {
        roles: [s.role],
        external_email: s.email.trim(),
        raci_role: s.raciRole ?? inferRaciFromStakeholderRole(s.role),
      }),
    ),
  )
  return results.flatMap((result, i) =>
    result.status === 'rejected'
      ? [{ email: stakeholders[i]?.email.trim() ?? '', error: result.reason }]
      : [],
  )
}
